/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { remoteSessionsListBindings } from "../funcs/remoteSessionsListBindings.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListBindingsResponseBody } from "../models/components/listbindingsresponsebody.js";
import {
  ListBindingsRequest,
  ListBindingsSecurity,
} from "../models/operations/listbindings.js";
import { unwrapAsync } from "../types/fp.js";
export type RemoteSessionsListBindingsQueryData = ListBindingsResponseBody;

export function prefetchRemoteSessionsListBindings(
  queryClient: QueryClient,
  client$: GramCore,
  request: ListBindingsRequest,
  security?: ListBindingsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRemoteSessionsListBindingsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRemoteSessionsListBindingsQuery(
  client$: GramCore,
  request: ListBindingsRequest,
  security?: ListBindingsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RemoteSessionsListBindingsQueryData>;
} {
  return {
    queryKey: queryKeyRemoteSessionsListBindings({
      principalId: request.principalId,
      userSessionIssuerId: request.userSessionIssuerId,
      gramSession: request.gramSession,
      gramProject: request.gramProject,
    }),
    queryFn: async function remoteSessionsListBindingsQueryFn(
      ctx,
    ): Promise<RemoteSessionsListBindingsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(remoteSessionsListBindings(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRemoteSessionsListBindings(
  parameters: {
    principalId: string;
    userSessionIssuerId: string;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "remoteSessions", "listBindings", parameters];
}
